import axios from 'axios';
import { Message } from "element-ui";
import storage from '../utils/storage'
const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 2000  // 不同小程序对接同一后台

let API_BASE_URL = 'https://shop.winksshowp.com'

// 163 第一步 图片上传 获取token
export const getImageToken = async (name) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/service/aliyun/ossaction.ashx?appid=${appid}&filename=${name}`);
        const { data } = response;
        return { data };
    } catch (error) {
        // console.error('Error fetching token:', error);
        Message.error('接口请求失败');
        throw error; // 根据需要处理错误
    }
}

// 164 第二步 上传到阿里云（图片）
export const uploadImageOss = async (res, files) => {
    try {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", files);
        const response = await axios.post(`https://upload.vwingist.com/`, formData);
        const { status } = response;
        return {status};
    } catch (error) {
        // console.error('Error fetching token:', error);
        Message.error('接口请求失败');
        throw error; // 根据需要处理错误
    }
}

// 693 第一步 视频上传 获取token
export const getVideoToken = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/service/aliyun/ossaction_video.ashx?appid=${appid}`);
        const { data } = response;
        return { data };
    } catch (error) {
        // console.error('Error fetching token:', error);
        Message.error('接口请求失败');
        throw error; // 根据需要处理错误
    }
}

// 694 第二步 上传到阿里云（视频）
export const uploadVideoOss = async (res, files) => {
    try {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", files);
        const response = await axios.post(`https://video.vwingist.com/`, formData);
        const { status } = response;
        return {status};
    } catch (error) {
        // console.error('Error fetching token:', error);
        Message.error('接口请求失败');
        throw error; // 根据需要处理错误
    }
}
